import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Store } from '@ngrx/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { DataLayer } from '../../common/datalayer/datalayer';
import { DeviceTypeHelper } from '../../common/device-type-helper';
import { QueryStringHelper } from '../../common/query-string-helper';
import { ApplicationConfig } from '../../config/config';
import { ICorporatePartner } from '../../corporate-partner/corporate-partner.interface';
import { getCorporatePartner } from '../../corporate-partner/corporate-partner.method';
import { ContentCountryLanguage } from '../../model/content/contentCountryLanguage.model';
import { ContentDarkSite } from '../../model/content/contentDarkSite.model';
import { ContentLogo } from '../../model/content/contentLogo.model';
import { UnSupportedBrowser } from '../../model/content/contentUnsupportedBrowser.model';
import { ContentAuxiliaryNavigation } from '../../model/content/contentauxiliarynavigation.model';
import { ContentBook } from '../../model/content/contentbook.model';
import { Airports, Dates, RecentSearch } from '../../model/recent-search.model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { TrackerDataService } from '../../services/acctactvty/trackerData.service';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import {
  UpdateAirportsActionPayload,
  UpdateDatesActionPayload
} from '../../store';
import { MobileWidgetComponent } from '../mobile-widget/mobile-widget.component';
import { SwitchingAccountService } from '../switching-account/switching-account.service';

@Component({
  selector: 'ngc-global-nav-slim',
  templateUrl: 'global-nav-slim.component.html',
  providers: [CookieHelper],
  animations: [
    trigger('navigation', [
      state('true', style({ left: '-100%', display: 'none' })),
      state('false', style({ left: '0%', display: 'block' })),
      transition('0 => 1', animate('.4s')),
      transition('1 => 0', animate('.4s'))
    ])
  ]
})
export class NgcGlobalNavSlimComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  isEDPFlag: any;
  @Output() bookSelected: EventEmitter<any> = new EventEmitter();
  @Output() disableBusinessPicker = new EventEmitter();
  @Input() isMobile: any;
  @Input() userId: any;
  @Input() corpPartner: ICorporatePartner;
  @Input() businessAccountOptionsList = { isOaSmeAccount: false };
  @Input() checkDefaults: any;
  @Input() isShoppingAwsFlow = false;
  @Input() nextgenPage = false;
  @Input() mobileWidgetComponent: MobileWidgetComponent;
  @ViewChild('ngcMobileWidget') ngcMobileWidget: MobileWidgetComponent;
  @Input() showMobileWidget = false;
  contentServiceHeaderFooterSubscribe: Subscription;
  countryLanguageContent: ContentCountryLanguage;
  unSupportedBrowser: UnSupportedBrowser;
  isEnabled = 'true';
  showCookieTerms = false;
  isDarkSiteEnabled = true;
  isLightHeaderFooterEnable = false;
  isWidgetEnable = false;
  selectedNavItem;
  isMobileDevice = false;
  isPrimaryNavExpandCollapse = false;
  isNotHome = false;
  isMobileAndTabletDevice = false;
  businessUser = false;
  displayBusinessTypeSection = false;
  disableBusinessHomePage: any;
  restrictProfileSelector = false;
  isBusinessLoginDisabled = true; // DDCFB
  contentInterstitialBanner: any;
  prefCookieValue: any;
  hasCorpCookie: any;
  contentContactUs: any;
  contentMyFlightPanel: any;
  auxiliaryArr: ContentAuxiliaryNavigation[];
  isAlertAdvisory = false;
  navigation = true;
  isloggedIn = false;
  prefCityCode: string;
  custId: any;
  trackerServiceRecentSearchesSubscribe: Subscription;
  recentSearchsAvailable = false;
  recentSearchSelected: RecentSearch;
  recentSearches: RecentSearch[] = [];
  paxcount: string;
  tripType: string;
  toCity: string;
  fromCity: string;
  departDate: string;
  returnDate: string;
  showFlag: boolean;
  tempEdpFlag = false;
  contentHeaderFooterData: ContentBook;
  contentLogoData: ContentLogo;
  contentHeaderData: any;
  editSearchLabel: any;
  hideSearchLabel: any;
  slimheaderLogoUrl: any;
  slimheaderLogo: any;
  slimheaderLogoAltText: any;
  mainLogoData: any;
  vaPaxDropDown = false;
  windowHeight = 0;
  partnerId = 'default';
  moveFocusTo: any;
  moveFocusToLogged: any;
  currentParentEle: any;
  disableCLS: any;
  isSlimHeader: any;
  isHamberger: any;
  widgetContainerTop: any;
  public crpInfo: any;
  public deviceTypes: any = [];
  public storeModalRef: BsModalRef;
  public darkSiteThemeContent: ContentDarkSite;
  public isWarmState = false;
  public isReady = false;
  public accountSummaryServiceSubscribe: Subscription;
  recentSearch: any;
  multiCityRecentSearchesSubscribtion: Subscription;
  multiCityData: any;
  triggerDefault: string;
  deepLinkCacheKey: string;
  deepLinkXssid: string;
  deepLinkVendor: string;
  canBookNonRefundable: string;
  private ngUnsubscribe: Subject<any> = new Subject();
  private unsubscribe: Subject<void> = new Subject();
  showNewProfileSelector: boolean;
  businessList = {
    isOaSmeAccount: '',
    partnerId: '',
    accountIndex: 0,
    restrictPaxToOne: false,
    displayInlineText: ''
  };

  restrictNewPaxToOne = false;
  isModifyClicked = false;
  constructor(
    private appconfig: ApplicationConfig,
    private contentService: ContentHeaderFooterService,
    private el: ElementRef,
    private rend: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _deviceTypeHelper: DeviceTypeHelper,
    private trackerDataService: TrackerDataService,
    private cookieHelper: CookieHelper,
    public switchingAccountService: SwitchingAccountService,
    private srv: CommonService,
    private store: Store<any>,
    private accountSummaryDetails: AccountSummaryService,
    private cdf: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private queryStringHelper: QueryStringHelper,
    private datalayer: DataLayer,
    private userSession: UserSessionService,
    private loggingService: LoggingService
  ) {}

  processData() {
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              this.showNewProfileSelector =
                !!data?.header?.enableNewProfileSelector;
              if (this.showNewProfileSelector) {
                const accountCookie =
                  this.cookieHelper.getCookieValue('account');
                if (accountCookie && accountCookie.length) {
                  const accountCookieJson = JSON.parse(accountCookie);
                  if (accountCookieJson['isBusiness']) {
                    this.businessList =
                      accountCookieJson['businessAccountOptionsList'];
                    this.restrictNewPaxToOne =
                      this.businessList.restrictPaxToOne;
                  }
                }
              }
              this.restrictProfileSelector = this.srv.hidingProfileSelector();
              if (data.header.auxiliaryNavigation.get('interstitialBanner')) {
                this.contentInterstitialBanner =
                  data.header.auxiliaryNavigation.get(
                    'interstitialBanner'
                  ).details;
              }
              if (
                data.header.disableBusinessHomePage &&
                data.header.disableBusinessHomePage !== null &&
                data.header.disableBusinessHomePage !== undefined &&
                data.header.disableBusinessHomePage !== ''
              ) {
                this.isBusinessLoginDisabled =
                  data.header.disableBusinessHomePage.toLowerCase() === 'true'
                    ? true
                    : false;
              } else {
                this.isBusinessLoginDisabled = true;
              }
              // this.getEdpFlag(this.tempEdpFlag, this.isWarmState);
              this.disableBusinessPicker.emit(this.isBusinessLoginDisabled);
              if (!this.isBusinessLoginDisabled) {
                this.prefCookieValue = this.cookieHelper.getCookies('prefUI');
                // checks if corp cookie exists or not
                this.hasCorpCookie = this.cookieHelper.getCookies('corp');
                if (this.hasCorpCookie) {
                  const corpCookie = this.cookieHelper.getCookies('corp');
                  const passCorpName = corpCookie
                    .split('|')[1]
                    .split('=')[1]
                    .replace(/#/g, ' ');
                  this.businessUser = true;
                  this.switchingAccountService.toggleAccount(
                    this.hasCorpCookie,
                    false
                  );
                  this.switchingAccountService.setCorporateName(passCorpName);
                  this.switchingAccountService.setIntranetlink(true);
                  this.displayBusinessTypeSection = true;
                }
              }
              this.corpPartner = this.srv.getCorpPartner(
                this.partnerId,
                this.corpPartner,
                this.deepLinkCacheKey
              );
              const contentData = data;
              this.contentHeaderData = data;
              if (
                contentData.header !== undefined &&
                contentData.header.primaryNavigations.get('book') !== undefined
              ) {
                this.contentHeaderFooterData =
                  data.header.primaryNavigations.get('book').details;
                if (this.contentHeaderFooterData.passengertype.length !== 0) {
                  this.vaPaxDropDown = true;
                }
                this.checkForDataAndPopulateRecentSearches();
                this.editSearchLabel =
                  this.contentHeaderFooterData.altSearchLabel;
                if (contentData.logo !== undefined) {
                  this.contentLogoData = contentData.logo;
                  if (
                    this.contentLogoData.slimheaderLogo !== undefined ||
                    this.contentLogoData.slimheaderLogoUrl !== undefined ||
                    this.contentLogoData.slimheaderLogoAltText !== undefined
                  ) {
                    this.slimheaderLogo = this.contentLogoData.slimheaderLogo;
                    this.slimheaderLogoUrl =
                      this.contentLogoData.slimheaderLogoUrl;
                    this.slimheaderLogoAltText =
                      this.contentLogoData.slimheaderLogoAltText;
                  }
                }
              }
              this.countryLanguageContent = data.footer.countryLanguage;
              if (contentData && contentData.unsupportedBrowserPopup) {
                this.unSupportedBrowser = contentData.unsupportedBrowserPopup;
              }

              if (contentData && contentData.darkSite) {
                this.darkSiteThemeContent = contentData.darkSite;
                if (this.darkSiteThemeContent.isEnabled === this.isEnabled) {
                  this.showCookieTerms = false;
                  if (
                    this.darkSiteThemeContent.level ===
                    this.appconfig.get('APP_DARKSITE_LEVEL_0')
                  ) {
                    this.isDarkSiteEnabled = false;
                    this.isWidgetEnable = true;
                    const body = document.getElementsByTagName('body')[0];
                    // body.classList.add('dark-site');
                  } else if (
                    this.darkSiteThemeContent.level ===
                      this.appconfig.get('APP_DARKSITE_LEVEL_1') ||
                    this.darkSiteThemeContent.level ===
                      this.appconfig.get('APP_DARKSITE_LEVEL_2')
                  ) {
                    this.isDarkSiteEnabled = true;
                    this.isWidgetEnable = true;
                    this.isPrimaryNavExpandCollapse = true;
                    const activeItem =
                      this.el.nativeElement.querySelector('.active-menu');
                    if (activeItem) {
                      this.rend.removeClass(activeItem, 'active-menu');
                    }
                  } else {
                    this.isDarkSiteEnabled = true;
                    this.isWidgetEnable = false;
                  }
                }
              }
              if (this.appconfig.get('APP_DISABLE_LEGACY') === 'false') {
                this.isNotHome = true;
                this.isMobileAndTabletDevice = false;
              }
              if (contentData && contentData.header) {
                if (contentData.header.primaryNavigations) {
                  const mainNav = Array.from(
                    contentData.header.primaryNavigations.values()
                  );
                  if (data.header.auxiliaryNavigation.get('contactUs')) {
                    this.contentContactUs =
                      data.header.auxiliaryNavigation.get('contactUs').details;
                  }
                  if (data.header.auxiliaryNavigation.get('myFlightPanel')) {
                    this.contentMyFlightPanel =
                      data.header.auxiliaryNavigation.get(
                        'myFlightPanel'
                      ).details;
                  }
                  if (mainNav && mainNav[0]) {
                    if (this.isPrimaryNavExpandCollapse) {
                      this.selectedNavItem = '';
                    } else {
                      this.selectedNavItem = mainNav[0]['id'];
                    }
                  }
                }

                if (contentData.header.auxiliaryNavigation) {
                  this.auxiliaryArr = Array.from(
                    contentData.header.auxiliaryNavigation.values()
                  );
                  this.removeSignupfromAuxillaryArray();
                }
                // this.cdf.detectChanges();
              }
            },
            (err) => {
              this.loggingService.log(
                `content header footer json service call returned this error ${err}`
              );
            }
          );
    }
    this.switchingAccountService.corporatePartnerChange.subscribe(
      (corpPartner: ICorporatePartner) => {
        this.corpPartner = corpPartner;
        const account =
          this.switchingAccountService.getAccountCookie('account');
        if (account && account.length) {
          const parseAccount = JSON.parse(account);
          this.businessAccountOptionsList =
            parseAccount['businessAccountOptionsList'];
          if (this.showNewProfileSelector) {
            this.businessUser = parseAccount['isBusiness'];
          }
        }
        this.corpPartner = this.srv.getCorpPartner(
          this.partnerId,
          this.corpPartner,
          this.deepLinkCacheKey
        );
        this.cdf.detectChanges();
      }
    );
    if (this.appconfig.onBrowser) {
      this.setRecentSearchHeader();
    }
  }

  // TODO: SSR is breaking with use of KeyboardEvent
  @HostListener('document:keyup', ['$event']) handleKeyboardEvent(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.handleEscapeEvent(event);
    }
  }

  @HostListener('document:keydown', ['$event']) onkeydown(event) {
    if (event.keyCode === 9 && event?.target?.id === 'btnSubmit') {
      const findParentEle = document.querySelector(
        '#main_nav div a[aria-expanded = "true"]'
      );
      const modifylink: HTMLElement = document.querySelector(
        '.modify-btn-border'
      ) as HTMLElement;
      if (
        findParentEle !== null &&
        findParentEle !== undefined &&
        findParentEle?.className !== 'modify-link modify-btn-border'
      ) {
        const focusNextEle =
          findParentEle.parentElement.nextElementSibling.nextElementSibling.querySelector(
            'a'
          );
        modifylink.click();
        focusNextEle.focus();
        event.preventDefault();
      } else if (findParentEle.className === 'modify-link modify-btn-border') {
        this.moveFocusTo = document.querySelector('.sign-up');
        if (this.moveFocusTo !== null) {
          modifylink.click();
          this.moveFocusTo.focus();
          event.preventDefault();
        } else if (
          this.moveFocusTo == null &&
          document.querySelector('.logged-in-container') !== undefined &&
          document.querySelector('.logged-in-container') !== null
        ) {
          this.moveFocusToLogged = document.querySelector(
            '.logged-in-container'
          );
          modifylink.click();
          this.moveFocusToLogged.focus();
          event.preventDefault();
        }
      }
    }
  }

  disableBusinessPage(event) {
    // #todo
  }

  logOut() {
    // #todo
  }

  handleEscapeEvent(event) {
    const isModalOpen = document
      .getElementsByTagName('body')[0]
      .classList.contains('modal-open');
    if (
      event.keyCode === 27 &&
      isModalOpen &&
      this.storeModalRef !== undefined &&
      this.storeModalRef !== null
    ) {
      const modalContainer = document.getElementsByTagName('modal-container');
      if (
        modalContainer !== undefined &&
        modalContainer !== null &&
        modalContainer.length > 0
      ) {
        if (modalContainer[0].classList.contains('search-footer-modal')) {
          this.storeModalRef.content.footerSearchModalLoaded = false;
        } else if (
          modalContainer[0].classList.contains('notification-header-modal')
        ) {
          this.storeModalRef.content.notificationModalLoaded = false;
        } else if (
          modalContainer[0].classList.contains('notification-loggedin-modal')
        ) {
          const el = this.el.nativeElement.querySelector('.toggle-up');
          if (el !== null && el !== undefined && el.querySelector('img')) {
            el.className = 'toggle-flyout';
            el.querySelector('img').setAttribute('alt', 'Collapsed');
          }
          this.storeModalRef.content.loggedInModalLoaded = false;
        }
        this.storeModalRef.hide();
      }
      document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    if (isPlatformBrowser(this.platformId) && document && window) {
      const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      const height = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      );
      this.windowHeight = height;
      if (width < 1025 && width > 767) {
        const mobileWidget = document.getElementsByClassName(
          'mobile-widget-modal'
        );
        if (
          mobileWidget !== undefined &&
          mobileWidget !== null &&
          mobileWidget.length > 0
        ) {
          const closeModalContainer =
            document.getElementsByTagName('modal-container');
          const closeBackdrop =
            document.getElementsByTagName('bs-modal-backdrop');
          if (
            closeModalContainer &&
            closeModalContainer !== undefined &&
            closeBackdrop &&
            closeBackdrop !== undefined
          ) {
            this.rend.setStyle(closeModalContainer[0], 'display', 'none');
            this.rend.setStyle(closeBackdrop[0], 'display', 'none');
          }
        }
      }
      if (width < 992) {
        this.isMobileAndTabletDevice = true;
        if (this.appconfig.get('APP_DISABLE_LEGACY') === 'false') {
          this.isNotHome = true;
          const activeItem =
            this.el.nativeElement.querySelector('.active-menu');
          if (activeItem) {
            this.rend.removeClass(activeItem, 'active-menu');
          }
        }
      } else {
        this.isMobileAndTabletDevice = false;
        if (this.appconfig.get('APP_DISABLE_LEGACY') === 'false') {
          if (this.isNotHome === true) {
            const activeItem =
              this.el.nativeElement.querySelector('.active-menu');
            if (activeItem) {
              this.rend.removeClass(activeItem, 'active-menu');
            }
          }
        }
      }
      if (!this.navigation) {
        this.navigationDrawer();
      }
      this.cdf.detectChanges();

      if (this.appconfig.get('APP_DISABLE_LEGACY') === 'false') {
        this.isMobileAndTabletDevice = false;
      }
      this.cdf.detectChanges();
    }
  }

  listenToEvents() {
    // TODO: needs to refactor code - B-664953
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('service-worker-token', () => {
        this.makeGetDashBrdData();
      });
    }
  }

  makeGetDashBrdData() {
    if (this.userSession.getServiceWorkerCheck()) {
      this.accountSummaryServiceSubscribe = this.getAccountSummary();
    }
    // if (this.recentSearchsAvailable) {
    //   if (this.recentSearchSelected !== null && this.recentSearchSelected !== undefined) {
    //     this.populateRecentSearchesToHeader();
    //   }
    // }
    if (isPlatformBrowser(this.platformId)) {
      this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
          if (this.deviceTypes.isMobile) {
            this.isMobileDevice = true;
          }
        });
    }

    this.cdf.detectChanges();
    this.captureUIUpdates();
  }

  ngOnInit() {
    try {
      if (isPlatformBrowser(this.platformId)) {
        this.showFlag = false;
        this.businessAccountOptionsList =
          this.switchingAccountService.initializeViewData();
        this.processValuesCorp();
        this.checkLightHeaderFooter();
        this.makeGetDashBrdData();
      }
    } catch (error) {
      console.error('in catch block of on init', error);
    }
  }

  getAccountSummary() {
    return this.accountSummaryDetails.getAccountSummaryDetails().subscribe(
      (res) => {
        this.isReady = true;
        if (res !== null) {
          this.isWarmState = res.isWarmState;
          this.canBookNonRefundable = res['canBookNonRefundable'];
          this.datalayer.setDdcfbData(res);
          // console.log('this.isWarmState', this.isWarmState);
        }
      },
      (err) => {
        this.isReady = true;
      }
    );
  }

  ngOnChanges(change: SimpleChanges) {
    if (isPlatformBrowser(this.platformId)) {
      if (
        change.checkDefaults &&
        (this.checkDefaults === 'add' || this.checkDefaults === 'remove')
      ) {
        this.triggerDefault = this.checkDefaults;
        this.cdf.detectChanges();
      }
      this.listenToEvents();
    }
  }

  checkLightHeaderFooter() {
    if (
      this.appconfig !== undefined &&
      this.appconfig.get('APP_HEADERFOOTER_LIGHT_WEIGHT') === 'true'
    ) {
      this.isLightHeaderFooterEnable = true;
      this.isNotHome = true;
    }
  }

  /*
   * Listen to dynamic updates of airport codes or dates and update display accordingly
   */
  captureUIUpdates() {
    this.store
      // tslint:disable-next-line: no-shadowed-variable
      .select((state) => state?.slimNavReducer?.airportChanges)
      .subscribe(
        (values: UpdateAirportsActionPayload) => {
          if (values && values.fromCity && values.toCity) {
            this.fromCity = values.fromCity;
            this.toCity = values.toCity;
          }
        },
        (err) => {
          this.loggingService.log(
            `captureUIUpdates state.slimNavReducer.airportChanges subscription returned the following  error ${err}`
          );
        }
      );
    this.store
      // tslint:disable-next-line: no-shadowed-variable
      .select((state) => state?.slimNavReducer?.dateChanges)
      .subscribe(
        (values: UpdateDatesActionPayload) => {
          if (values && values.departDate) {
            this.departDate = values.departDate;
            this.returnDate = values.returnDate;
          }
        },
        (err) => {
          this.loggingService.log(
            `captureUIUpdates state.slimNavReducer.dateChanges subscription returned the following  error ${err}`
          );
        }
      );

    this.cdf.detectChanges();
  }

  closeModifyButton() {
    this.showFlag = true;
    this.cdf.detectChanges();
  }

  removeSignupfromAuxillaryArray() {
    if (this.auxiliaryArr) {
      const loginIndex = this.auxiliaryArr.findIndex(
        (item) => item.id === 'login'
      );
      const signupIndex = this.auxiliaryArr.findIndex(
        (item) => item.id === 'signup'
      );
      if (loginIndex > -1 && signupIndex > -1) {
        this.auxiliaryArr.splice(signupIndex, 1);
      }
    }
  }

  saveModalServiceRef(openedModalRef) {
    this.storeModalRef = openedModalRef;
  }

  getLoggedIn(flag: any) {
    this.isloggedIn = flag;
  }

  getPrefCity(flag) {
    if (flag !== undefined) {
      this.prefCityCode = flag;
    }
  }

  getCustId(flag) {
    if (flag !== undefined) {
      this.custId = flag;
    }
  }

  getCrpNames(crpData) {
    this.crpInfo = crpData;
  }

  setEdpFlag(res) {
    this.tempEdpFlag = res.flag;
    this.isWarmState = res.isWarmState;
  }

  getEdpFlag(res) {
    this.hasCorpCookie = this.cookieHelper.getCookies('corp');
    const hipmunkCookie =
      this.cookieHelper.getCookieValue('isHipmunk') !== null
        ? this.cookieHelper.getCookieValue('isHipmunk')
        : false;
    if (!this.isBusinessLoginDisabled) {
      const setBusinessFlag =
        (this.hasCorpCookie && !res.flag) || hipmunkCookie ? true : res.flag;
      this.isEDPFlag = setBusinessFlag;
      // code added for checking cookie existing or not and load
      let cookieObj = this.switchingAccountService.getAccountCookie('account');
      if (cookieObj && cookieObj.length) {
        cookieObj = JSON.parse(cookieObj);
        this.businessUser = cookieObj['isBusiness'];
        this.businessAccountOptionsList =
          cookieObj['businessAccountOptionsList'];
        this.partnerId = hipmunkCookie
          ? 'hipmunk'
          : this.businessAccountOptionsList['partnerId'];
        this.corpPartner = getCorporatePartner(this.partnerId);
        this.displayBusinessTypeSection = true; // cookieObj['isBusiness'];
        this.switchingAccountService.setBusinessUser(cookieObj['isBusiness']);
        this.switchingAccountService.toggleAccount(
          cookieObj['isBusiness'],
          false
        );
        if (this.hasCorpCookie && !res.flag) {
          this.switchingAccountService.displayBusinessAccounts(res.flag);
        }
      } else {
        // DDCFB - Hardcoding for now - need to move the entire logic once Login provides the correct data.
        const restrictedPageCookieObj =
          this.switchingAccountService.getAccountCookie('accountType');
        const showAsPersonal =
          (restrictedPageCookieObj !== '' &&
            restrictedPageCookieObj.split('-')[1] === 'true') ||
          (res.flag && res.isWarmState)
            ? false
            : setBusinessFlag;
        this.partnerId =
          restrictedPageCookieObj !== '' &&
          restrictedPageCookieObj.split('-')[1] === 'true'
            ? 'personal'
            : this.getPartnerId(hipmunkCookie, this.hasCorpCookie, res.flag);
        this.corpPartner = getCorporatePartner(this.partnerId);
        this.businessUser = showAsPersonal;
        this.displayBusinessTypeSection = setBusinessFlag;
        this.switchingAccountService.setBusinessUser(showAsPersonal);
        this.switchingAccountService.toggleAccount(showAsPersonal, false);
        if (this.hasCorpCookie && !res.flag) {
          this.switchingAccountService.displayBusinessAccounts(res.flag);
        }
      }
      // }
    }
    this.isEDPFlag = res.flag;
  }

  getPartnerId(hipmunkCookie, corpCookie, flag) {
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    if (hipmunkCookie) {
      return 'hipmunk';
    } else if (corpCookie) {
      return 'edp';
    } else if (setPartnerToPersonal && setPartnerToPersonal.length) {
      return setPartnerToPersonal;
    } else {
      return 'default';
    }
  }

  /*
   * We want to populate recent searches only after header json data is available
   * We don't know which api call will execute first so we use two conditions
   * We only populate recent searches when both api calls have succeeded
   */
  checkForDataAndPopulateRecentSearches() {
    if (this.populateRecentSearchValidation()) {
      this.populateRecentSearchesToHeader();
    }
  }

  populateRecentSearchValidation() {
    return (
      this.recentSearchsAvailable &&
      this.contentHeaderFooterData &&
      this.recentSearchSelected &&
      this.recentSearchSelected.selectTripType &&
      this.recentSearchSelected.selectTripType.toLowerCase() !== 'multicity'
    );
  }

  /**
   * Get backend data for round-trip and one-way
   *
   * @memberof NgcGlobalNavSlimComponent
   */
  async setRecentSearchesToHeader() {
    this.multiCityRecentSearchesSubscribtion = this.trackerDataService
      .getRecentSearches()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (res) => {
          if (res !== null && res !== undefined && res !== '') {
            if (res.length > 0) {
              res.forEach((resp, index) => {
                this.recentSearches.push(new RecentSearch(resp));
              });
              if (this.recentSearches.length > 0) {
                this.recentSearchSelected = this.recentSearches[0];
                this.recentSearchsAvailable = true;
                this.checkForDataAndPopulateRecentSearches();
              }
            }
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
  }

  /**
   * Populate properties related to recent searches
   *
   * @memberof NgcGlobalNavSlimComponent
   */
  populateRecentSearchesToHeader() {
    // Get casted data
    // NOTE: The casting here (as Airports) is because the property airports have a composite type, Airports or Airports[]
    const airports = this.recentSearchSelected.airports as Airports;
    const dates = this.recentSearchSelected.dates as Dates;

    // Get cities initial and end city
    this.fromCity = airports.fromAirportcode;
    this.toCity = airports.toAirportcode;

    // Get departure and return dates
    this.departDate = dates.departureDate;
    this.returnDate = dates.returnDate;

    // If contentHeaderFooterData exist
    if (this.contentHeaderFooterData !== undefined) {
      // Get trip type label value from local store data
      if (
        this.contentHeaderFooterData.tripTypes !== undefined &&
        this.contentHeaderFooterData.tripTypes.length > 0
      ) {
        this.contentHeaderFooterData.tripTypes.forEach((element) => {
          if (
            element.tripTypeValue === this.recentSearchSelected.selectTripType
          ) {
            this.tripType = element.tripTypeTitle;
          }
        });
      }

      // Get the passenger count and use the proper correspondant label
      if (
        this.contentHeaderFooterData.passengers !== undefined &&
        this.contentHeaderFooterData.passengers.length > 0
      ) {
        this.contentHeaderFooterData.passengers.forEach((element) => {
          if (
            element.passengerId === this.recentSearchSelected.passenger ||
            element.passengerId === '' + this.recentSearchSelected.passenger
          ) {
            this.paxcount = element.passengerTitle;
          }
        });
      }
    } else {
      // If contentHeaderFooterData does not exist
      // Assign static/harcoded label data
      if (this.recentSearchSelected.selectTripType === 'ROUND_TRIP') {
        this.tripType = 'round trip';
      } else if (this.recentSearchSelected.selectTripType === 'ONE_WAY') {
        this.tripType = 'one way';
      } else {
        this.tripType = 'multi city';
      }

      // Get the passenger count
      let passengerNumber = this.recentSearchSelected.passenger;

      // Update the passenger count summing all the passenger types
      if (this.vaPaxDropDown) {
        passengerNumber =
          +this.recentSearchSelected.adtCount +
          +this.recentSearchSelected.cnnCount +
          +this.recentSearchSelected.infantCount +
          +this.recentSearchSelected.gbeCount;
      }
      if (+passengerNumber > 1) {
        this.paxcount = passengerNumber + ' passengers';
      } else {
        this.paxcount = passengerNumber + ' passenger';
      }
    }

    // Update the changes
    this.cdf.detectChanges();
  }

  navItemClicked(event) {
    if (event && event !== '-1') {
      this.showFlag = true;
      this.selectedNavItem = event;
      this.cdf.detectChanges();
      if (this.mobileWidgetComponent) {
        this.mobileWidgetComponent.selectedNavItem = this.selectedNavItem;
        this.mobileWidgetComponent.openMobileWidgetModal();
        const modalContainer = document.querySelector('modal-container');
        if (modalContainer !== undefined && modalContainer !== null) {
          modalContainer.classList.add('show-mobile-widget');
        } // using a different class to add styles for mobile widget modal
      }
    }
  }

  toggleContent(event) {
    if (
      this.showMobileWidget &&
      event &&
      (event === 'book' ||
        event === 'check_in' ||
        event === 'my_trips' ||
        event === 'flightstatus')
    ) {
      this.navItemClicked(event);
    } else {
      this.showFlag = !this.showFlag;
      let toggleContent =
        this.el.nativeElement.querySelectorAll('.modify-link');
      toggleContent = Array.prototype.slice.call(toggleContent);
      if (toggleContent?.length > 0) {
        toggleContent.forEach((item) => {
          this.rend.setAttribute(item, 'aria-expanded', 'false');
        });
      }
      if (
        event.currentTarget?.classList.contains('modify-link') &&
        !this.showFlag
      ) {
        this.isModifyClicked = true;
      } else {
        this.isModifyClicked = false;
      }
      if (!this.showFlag) {
        this.triggerDefault = 'true';
        if (event && event.currentTarget) {
          event.currentTarget.setAttribute('aria-expanded', true);
        }
      } else {
        delete this.triggerDefault;
        if (event && event.currentTarget) {
          event.currentTarget.setAttribute('aria-expanded', false);
        }
      }
      if (!this.contentHeaderFooterData) {
        console.log(
          'toggleContent() -> this.contentHeaderFooterData is not yet available. Fix this code to execute only once this data is available. '
        );
      } else {
        if (!this.showFlag) {
          this.editSearchLabel = this.contentHeaderFooterData.altSearchLabel;
        } else {
          this.editSearchLabel =
            this.contentHeaderFooterData.hideEditSearchLabel;
        }
      }
    }
  }

  handleFocusEvent(event) {
    const targetElement = event.currentTarget;
    const modifyElement = targetElement.querySelector(
      '.open-flyout.icon-AdvSearchTriangle-up'
    );
    if (modifyElement !== undefined && modifyElement !== null) {
      const getTaggoleUpElement = modifyElement.classList.contains('toggle-up');
      if (
        event.keyCode === 9 &&
        getTaggoleUpElement !== undefined &&
        getTaggoleUpElement !== null
      ) {
        const moveFocusTo =
          this.el.nativeElement.querySelector('#fromAirportName');
        moveFocusTo.focus();
        event.preventDefault();
      }
    }
  }

  ngAfterViewInit() {
    // this.setRecentSearches();
    if (isPlatformBrowser(this.platformId)) {
      if (!this.showCookieTerms) {
        window.focus();
      }
    }
  }

  navigationDrawer() {
    const infoEL = document.getElementsByClassName(
      'information-sub-nav-container'
    );
    if (this.appconfig.get('APP_DISABLE_LEGACY') === 'false') {
      this.isMobileAndTabletDevice = true;
    }
    // if (this.toggle && this.toggle.nativeElement && this.toggle.nativeElement.offsetParent !== null) {
    this.navigation = !this.navigation;
    // }
    if (!this.navigation) {
      document.getElementsByTagName('body')[0].classList.add('hamburger-open');
      if (infoEL && infoEL.length > 0) {
        infoEL[0].classList.remove('fixed-top');
      }
    } else {
      document
        .getElementsByTagName('body')[0]
        .classList.remove('hamburger-open');
      if (infoEL && infoEL.length > 0) {
        infoEL[0].classList.add('fixed-top');
      }
    }
  }

  /**
   * Retrieve the multi-city search data and enable the multi-city component
   *
   * @memberof NgcGlobalNavSlimComponent
   */
  async getMultiCityData() {
    const mc_cache_key = this.cookieHelper.getMcCacheKey();
    this.multiCityRecentSearchesSubscribtion = (
      await this.trackerDataService.getMultiCityRecentSearches(mc_cache_key)
    )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response) => {
        this.multiCityData = response;
        this.recentSearches.push(new RecentSearch(response.value));
        if (this.recentSearches.length > 0) {
          this.recentSearchSelected = this.recentSearches[0];
          this.recentSearchsAvailable = true;
          this.populateRecentSearchesToHeaderOnMultiCity();
        }
      });
  }

  /**
   * Populate properties related to recent searches on MultiCity case
   *
   * @memberof NgcGlobalNavSlimComponent
   */
  populateRecentSearchesToHeaderOnMultiCity() {
    // Get casted data
    // NOTE: The casting here (as Airports) is because the property airports have a composite type, Airports or Airports[]
    const airports = this.recentSearchSelected.airports as Airports[];
    const dates = this.recentSearchSelected.dates as Dates[];

    // Get cities initial and end city
    this.fromCity = airports[0].fromAirportcode;
    this.toCity = airports[airports.length - 1].toAirportcode;

    // Get departure and return dates
    this.departDate = dates[0].departureDate;
    this.returnDate = dates[dates.length - 1].departureDate;

    // If contentHeaderFooterData exist
    if (this.contentHeaderFooterData !== undefined) {
      // Get trip type label value from local store data
      if (
        this.contentHeaderFooterData.tripTypes !== undefined &&
        this.contentHeaderFooterData.tripTypes.length > 0
      ) {
        this.contentHeaderFooterData.tripTypes.forEach((element) => {
          if (
            element.tripTypeValue === this.recentSearchSelected.selectTripType
          ) {
            this.tripType = element.tripTypeTitle;
          }
        });
      }

      // Get the passenger count and use the proper correspondant label
      if (
        this.contentHeaderFooterData.passengers !== undefined &&
        this.contentHeaderFooterData.passengers.length > 0
      ) {
        this.contentHeaderFooterData.passengers.forEach((element) => {
          if (element.passengerId === this.recentSearchSelected.passenger) {
            this.paxcount = element.passengerTitle;
          }
        });
      }
    } else {
      // If contentHeaderFooterData does not exist
      // Assign static/harcoded label data
      if (this.recentSearchSelected.selectTripType === 'ROUND_TRIP') {
        this.tripType = 'round trip';
      } else if (this.recentSearchSelected.selectTripType === 'ONE_WAY') {
        this.tripType = 'one way';
      } else {
        this.tripType = 'multi city';
      }

      // Get the passenger count
      let passengerNumber = this.recentSearchSelected.passenger;

      // Update the passenger count summing all the passenger types
      if (this.vaPaxDropDown) {
        passengerNumber =
          +this.recentSearchSelected.adtCount +
          +this.recentSearchSelected.cnnCount +
          +this.recentSearchSelected.infantCount +
          +this.recentSearchSelected.gbeCount;
      }
      if (+passengerNumber > 1) {
        this.paxcount = passengerNumber + ' passengers';
      } else {
        this.paxcount = passengerNumber + ' passenger';
      }
    }

    // Update the changes
    this.cdf.detectChanges();
  }

  ngOnDestroy() {
    // Loadtest ObsUnsub added
    this.ngUnsubscribe.next();
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.trackerServiceRecentSearchesSubscribe) {
      this.trackerServiceRecentSearchesSubscribe.unsubscribe();
    }
    if (this.multiCityRecentSearchesSubscribtion) {
      this.multiCityRecentSearchesSubscribtion.unsubscribe();
    }
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
  }

  scrollTop() {
    if (window) {
      window.scrollTo(0, 0);
    }
  }

  async setDeepLinkSearch(recentSearchValue, tripType) {
    this.cookieHelper.setCookies('trip_type', tripType);
    if (tripType === 'MULTICITY' || tripType === 'multicity') {
      console.log(
        '%c Deep Link search value is already retrieved',
        'color: yellow'
      );
    } else {
      await this.setRecentSearch(recentSearchValue);
    }
  }

  async setRecentSearch(recentData) {
    try {
      if (recentData) {
        const data =
          await this.trackerDataService.postRecentSearchesForDeepLink(
            recentData
          );
        this.cookieHelper.setCookieName(
          this.deepLinkCacheKey,
          this.deepLinkXssid,
          1,
          true
        );
        console.log(
          '%c Deep Link search value was successfully posted as below',
          'color: yellow'
        );
      } else {
        console.log(
          '%c Deep Link search value is already posted',
          'color: yellow'
        );
      }

      let deepLinkResponse;
      deepLinkResponse =
        await this.trackerDataService.getRecentSearchForDeepLink();
      this.cookieHelper.deleteCookie('deepLinkSlimHeaderValue');
      if (deepLinkResponse) {
        for (const deepLinkData of deepLinkResponse) {
          this.recentSearches.push(new RecentSearch(deepLinkData));
        }
        if (this.recentSearches.length > 0) {
          this.recentSearchSelected = this.recentSearches[0];
          this.recentSearchsAvailable = true;
          this.checkForDataAndPopulateRecentSearches();
        }
      } else {
      }
    } catch (error) {
      console.log(
        '%c a Deep Link search value was not posted',
        'color: yellow'
      );
    }
  }

  checkToCallDeepLinkSlimNav() {
    const isCookiePresent =
      this.cookieHelper.getCookieValue(this.deepLinkCacheKey) &&
      this.cookieHelper.getCookieValue(this.deepLinkCacheKey) ===
        this.deepLinkXssid
        ? true
        : false;
    if (!isCookiePresent) {
      return true;
    } else if (isCookiePresent && !this.recentSearch) {
      return true;
    } else {
      return false;
    }
  }

  async setDeepLinkSlimNav(tripType, isCookiePresent) {
    const callDeepLinkSlimNav = this.checkToCallDeepLinkSlimNav();
    if (callDeepLinkSlimNav && !isCookiePresent) {
      this.multiCityRecentSearchesSubscribtion = this.trackerDataService
        .getMultiCityRecentSearches(this.deepLinkCacheKey)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(async (response) => {
          if (response !== null && response !== undefined) {
            const updateSearch = new RecentSearch(response.value);
            tripType =
              updateSearch &&
              updateSearch.selectTripType &&
              updateSearch.selectTripType
                ? updateSearch.selectTripType
                : tripType;
            if (
              tripType &&
              tripType !== 'MULTICITY' &&
              tripType !== 'multicity'
            ) {
              updateSearch.airports = response.value.airports[0];
              updateSearch.dates = response.value.dates[0];
              await this.setDeepLinkSearch(updateSearch, tripType);
            } else {
              this.cookieHelper.setCookies(
                'mc_cache_key',
                this.deepLinkCacheKey
              );
              this.cookieHelper.setCookies('trip_type', 'MULTICITY');
              this.multiCityData = response;
              this.recentSearches.push(new RecentSearch(response.value));
              if (this.recentSearches.length > 0) {
                this.recentSearchSelected = this.recentSearches[0];
                this.recentSearchsAvailable = true;
                this.populateRecentSearchesToHeaderOnMultiCity();
              }
            }
          }
        });
    } else if (callDeepLinkSlimNav && isCookiePresent) {
      await this.setDeepLinkSearch(undefined, tripType);
    } else {
      console.log('Hey hey what we are doing here');
    }
  }

  getQueryParams(queryParamName: string) {
    let queryParamValue;
    if (
      this._route.snapshot.queryParams &&
      this._route.snapshot.queryParams[queryParamName] !== undefined &&
      this._route.snapshot.queryParams[queryParamName] !== null
    ) {
      queryParamValue = this._route.snapshot.queryParams[queryParamName];
    } else {
      queryParamValue = undefined;
    }
    if (!queryParamValue) {
      queryParamValue =
        this.queryStringHelper.getParameterByName(queryParamName);
    }
    return queryParamValue;
  }

  async getDeepLinkValues() {
    try {
      const isDeepLinkProcess =
        this.srv.getDeepLinkVendor() === '' ? false : true;
      if (isDeepLinkProcess) {
        this.deepLinkXssid = this.getQueryParams('deepLinkXssid');
        this.deepLinkCacheKey = this.getQueryParams('cacheKeySuffix');
        this.deepLinkVendor = this.getQueryParams('vendorID');
      }
      const deepLinkCacheKeyCookieValue =
        this.cookieHelper.getCookieValue('deepLinkCacheKey');
      const deepLinkVendorCookieValue = this.cookieHelper.getCookieValue(
        'deepLinkVendor' + this.deepLinkCacheKey
      );
      if (
        isDeepLinkProcess &&
        this.deepLinkVendor &&
        this.deepLinkVendor === this.srv.getDeepLinkVendor()
      ) {
        this.srv.setDeepLinkVendorCookie(
          this.deepLinkVendor,
          this.deepLinkCacheKey
        );
        this.corpPartner = getCorporatePartner(this.deepLinkVendor);
      } else if (
        isDeepLinkProcess &&
        this.deepLinkCacheKey &&
        this.deepLinkCacheKey === deepLinkCacheKeyCookieValue &&
        deepLinkVendorCookieValue &&
        deepLinkVendorCookieValue === this.srv.getDeepLinkVendor()
      ) {
        this.corpPartner = getCorporatePartner(deepLinkVendorCookieValue);
      } else {
        this.corpPartner = getCorporatePartner(this.partnerId);
      }
    } catch (error) {
      this.corpPartner = getCorporatePartner(this.partnerId);
    }
    this.processData();
  }

  async processValuesCorp() {
    await this.getDeepLinkValues();
  }

  processDeepLinlSlimNav() {
    const isDeepLinkProcess =
      this.srv.getDeepLinkVendor() === '' ? false : true;
    return this.deepLinkCacheKey && this.deepLinkXssid && isDeepLinkProcess;
  }

  async setRecentSearchHeader() {
    const tripType = this.cookieHelper.getTripType();
    const isCookiePresent =
      this.cookieHelper.getCookieValue(this.deepLinkCacheKey) &&
      this.cookieHelper.getCookieValue(this.deepLinkCacheKey) ===
        this.deepLinkXssid
        ? true
        : false;
    if (this.processDeepLinlSlimNav()) {
      await this.setDeepLinkSlimNav(tripType, isCookiePresent);
    } else {
      this.processSlimNav(tripType);
    }
  }

  processSlimNav(tripType) {
    if (tripType && (tripType === 'multicity' || tripType === 'MULTICITY')) {
      this.getMultiCityData();
    } else {
      this.setRecentSearchesToHeader();
    }
  }
}
